import { Fare } from '@silbo/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from '../../../../toast';
import { logToastClick } from '../../../../utils/log-notification-action';

const NEW_FARE_TOAST_DURATION = 3000;

/**
 * displays a toast for 3s when `fares`.length increases
 */
export const useNewFareToast = (fares: Fare[] | undefined) => {
  const [previousFaresState, setPreviousFaresState] = useState(fares);
  const { t } = useTranslation('patient-transport');
  useEffect(() => {
    if ((previousFaresState?.length || 0) < (fares?.length || 0)) {
      toast.info({
        message: t('toast.newFare'),
        duration: NEW_FARE_TOAST_DURATION,
        onDismiss: () => logToastClick('FARE_ASSIGNED', undefined, fares?.[0]?.id),
      });
    }
    setPreviousFaresState(fares);
  }, [fares, t, previousFaresState]);
};
